import { Wind } from "lucide-react";

const DIRS = ["N", "NE", "E", "SE", "S", "SO", "O", "NO"];

export function WindCompass({ direction = 0, compass = "", knots = null }) {
  const rotation = direction || 0;
  return (
    <div className="relative flex items-center justify-center" data-testid="wind-compass">
      <div className="relative h-40 w-40 sm:h-48 sm:w-48 rounded-full bg-sky-50 border border-slate-200 shadow-inner">
        {DIRS.map((d, i) => {
          const angle = i * 45;
          const rad = (angle - 90) * (Math.PI / 180);
          const r = 78;
          const cx = 50 + (r / 96) * 50 * Math.cos(rad);
          const cy = 50 + (r / 96) * 50 * Math.sin(rad);
          return (
            <span
              key={d}
              className={`absolute text-[10px] sm:text-xs font-bold ${
                d === "N" ? "text-orange-600" : "text-slate-400"
              }`}
              style={{
                left: `${cx}%`,
                top: `${cy}%`,
                transform: "translate(-50%, -50%)",
              }}
            >
              {d}
            </span>
          );
        })}

        <div
          className="absolute inset-0 flex items-start justify-center transition-transform duration-700 ease-out"
          style={{ transform: `rotate(${rotation}deg)` }}
        >
          <svg width="100%" height="100%" viewBox="0 0 100 100" className="drop-shadow">
            <polygon points="50,14 44,52 56,52" className="fill-orange-500" />
            <polygon points="50,86 44,52 56,52" className="fill-sky-300" />
            <circle cx="50" cy="52" r="4" className="fill-slate-800" />
          </svg>
        </div>

        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <Wind className="h-4 w-4 text-slate-300 mb-8" />
          <span className="mt-6 text-2xl font-head font-extrabold text-slate-900 leading-none">
            {compass || "--"}
          </span>
          <span className="text-[10px] uppercase tracking-widest text-slate-400 font-bold">
            direzione
          </span>
        </div>
      </div>
    </div>
  );
}
